import { useState, useEffect } from "react";

function ProfileTicketAddress(props){

  //setAddress={setAddress} setStreet={setStreet} setProvince={setProvince} setCity={setCity} setBattery={setBattery} 
  //street={street} province={province} city={city}
    // Define state to manage checkboxes
 /* const [checkboxes, setCheckboxes] = useState({
    Giga: false,
    ZRange: false,
    XRange: false,
    IStack: false,
  });*/

    // Function to handle checkbox changes
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        props.setCheckboxes({
          ...props.checkboxes,
          [name]: checked,
        });
      };


    return (
       
        <>

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Address Information </strong></p>
    </div>
</div>

   {/*  <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>*/}

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Address"
            value={props.address}
            style={{ marginTop: "10px" }}
            onChange={(e) => {
              props.setAddress(e.target.value);
            }}
            />
        </div>
    </div>

    <div class="col-sm-6">


<div className="">

  <input
  type="text"
  className="Login-form-field Login-animation a4 ProgressForm"
  name=""
  value={props.street}
  placeholder="Street Name"
  style={{ marginTop: "10px" }}
  onChange={(e) => {
    props.setStreet(e.target.value);
  }}
  />
</div>
</div>

</div>

<div class="row">


  

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            value={props.province}
            placeholder="Province"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
              props.setProvince(e.target.value);
            }}
            />
        </div>
    </div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            value={props.city}
            placeholder="City"
            style={{ marginTop: "10px" }}
            onChange={(e) => {
              props.setCity(e.target.value);
            }}
            />
        </div>
    </div>

</div>

<div class="row">

<div class="col-sm-12">
<hr style={{marginTop:"50px", marginBottom:"50px"}} />
<div style={{display: "flex"}}>
        <p className="card-title"><strong> Battery Trained On </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
          <label>
        <input style={{marginRight:"10px"}}
          type="checkbox"
          name="Giga"
          checked={props.checkboxes.Giga}
          onChange={handleCheckboxChange}
        />
       <span style={{marginRight:"50px"}}>Giga Rack</span> 
      </label>

      <label>
        <input style={{marginRight:"10px"}}
          type="checkbox"
          name="ZRange"
          checked={props.checkboxes.ZRange}
          onChange={handleCheckboxChange}
        />
        <span style={{marginRight:"50px"}}>Z-Range</span>
      </label>

      <label>
        <input style={{marginRight:"10px"}}
          type="checkbox"
          name="XRange"
          checked={props.checkboxes.XRange}
          onChange={handleCheckboxChange}
        />
        <span style={{marginRight:"50px"}}>X-Range</span>
      </label>

      <label>
        <input style={{marginRight:"10px"}}
          type="checkbox"
          name="IStack"
          checked={props.checkboxes.IStack}
          onChange={handleCheckboxChange}
        />
        <span style={{marginRight:"50px"}}>I-Stack</span>
      </label>
          
        </div>
    </div>

  


</div>






        </>
    )
}

export default ProfileTicketAddress;


